var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d-block",attrs:{"href":_vm.item.url,"target":"_blank"}},[_c('v-img',{attrs:{"src":_vm.item.image}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }